










































import { Component, Vue } from 'vue-property-decorator';
import '../../assets/css/AccountSetup.scss';
import { MedTransGoConstants } from '../../util/constants';
import { ObjectFactory } from '../../config/objectFactory';
import { Document, ProfileRequest } from '../../types/request';
import { ApiResponse, UploadFileResponse } from '@/types/response';
import { LoaderEvent, ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
import MessageBox from '../../components/MessageBox.vue';
import { CommonUtils } from '@/util/commonUtils';
// tslint:disable-next-line: no-var-requires
const TransporterRequiredDocuments = require('../../config/ProfileFormData.json');
// tslint:disable-next-line: no-var-requires
const ProfileFormData = require('../../config/ProfileFormData');
@Component({
    props: {
        request: Object,
    },
    components: {
        MessageBox,
    },
})
export default class UploadDocuments extends Vue {
    private isFormValid = false;
    private showDeleteConfirmBox = false;
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
    private selectedDocument: Document = {} as any;
    private disableSubmit = true;
    private async mounted() {
        this.getProfileRequest().isStepUDValid = false;
        const profileRequest = this.getProfileRequest();
        if (this.sessionInfo.scopes.includes('transporter') || this.sessionInfo.scopes.includes('homeHealthCare')) {
            if (!profileRequest.isStepUCValid && this.sessionInfo.scopes.includes('interpreter')) {
                this.$router.push({ name: MedTransGoConstants.VIEW_UPLOAD_CERTIFICATE_NAME });
            } else if (!profileRequest.isStepQnValid) {
                this.$router.push({ name: MedTransGoConstants.VIEW_TRANSPORTATION_QUESTIONNAIRE_NAME });
            } else if (!profileRequest.isStepHIValid) {
                this.$router.push({ name: MedTransGoConstants.VIEW_HEALTH_INSURANCE_INFO_NAME });
            }
        } else {
            this.$router.push({ name: MedTransGoConstants.VIEW_TRANSPORTATION_QUESTIONNAIRE_NAME });
        }
        ProfileFormData.documents.forEach((document: any) => {
            const objIndex = profileRequest.documents.findIndex(((obj) =>
                obj.name === document.name));
            if (objIndex >= 0) {
                const savedDoc = profileRequest.documents[objIndex] as any;
                const required = this.checkDocumentRequired(savedDoc, profileRequest.roles);
                if (!required && savedDoc.requiredFor) {
                    profileRequest.documents.splice(objIndex, 1);
                }
            } else {
                const required = this.checkDocumentRequired(document, profileRequest.roles);
                if (required && document.requiredFor) {
                    profileRequest.documents.push(document);
                }
            }
        });
        this.validateForm();
        this.disableSubmit = !this.isFormValid;
        const partnerService = ObjectFactory.getPartnerService();
        const response = await partnerService.getPartnerProfile(this.$store.state.serverUrl);
        if (response.success && response.data) {
            const partnerProfile = response.data;
            if (partnerProfile.transporterProfile) {
                const transporterProfile = partnerProfile.transporterProfile;
                if (transporterProfile.documents && transporterProfile.documents.length > 0) {
                    transporterProfile.documents.forEach((element) => {
                        const objIndex = profileRequest.documents.findIndex(((obj) =>
                            obj.name === element.name));
                        if (objIndex >= 0 && !element.rejected) {
                            profileRequest.documents[objIndex].resourceId = element.resourceId;
                            profileRequest.documents[objIndex].filename = element.filename;
                        }
                    });
                }
            }
            if (partnerProfile.homeHealthCareProfile) {
                const homeHealthCareProfile = partnerProfile.homeHealthCareProfile;
                if (homeHealthCareProfile.documents && homeHealthCareProfile.documents.length > 0) {
                    homeHealthCareProfile.documents.forEach((element) => {
                        const objIndex = profileRequest.documents.findIndex(((obj) =>
                            obj.name === element.name));
                        if (objIndex >= 0) {
                            profileRequest.documents[objIndex].resourceId = element.resourceId;
                            profileRequest.documents[objIndex].filename = element.filename;
                        }
                    });
                }
            }
        }
    }

    private back() {
        if (this.sessionInfo.scopes.includes('interpreter')) {
            this.$router.push({ name: MedTransGoConstants.VIEW_UPLOAD_CERTIFICATE_NAME });
        } else {
            this.$router.push({ name: MedTransGoConstants.VIEW_HEALTH_INSURANCE_INFO_NAME });
        }
    }

    private getProfileRequest(): ProfileRequest {
        return this.$props.request as ProfileRequest;
    }

    private async setDocument($event: any, document: Document, index: number) {
        const filename: string = $event.target.files[0].name.toLowerCase();
        if (document.name === 'Certificate of Insurance') {
            if (filename.endsWith('.pdf'))  {
                document.file = $event.target.files[0];
                document.filename = $event.target.files[0].name;
                this.validateForm();
                this.disableSubmit = false;
            } else {
                const toastEvent: ToastEvent = {
                message: 'File types should be PDF',
                title: 'Invalid file format.',
                varient: 'danger',
                timeout: 5000,
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                const inputName = `file-input${index}`;
                const element = this.$refs[inputName] as any;
                element[0].reset();
            }
        } else {
            if (filename.endsWith('.pdf') || filename.endsWith('.png') ||
            filename.endsWith('.jpeg') || filename.endsWith('.jpg')) {
            document.file = $event.target.files[0];
            document.filename = $event.target.files[0].name;
            this.validateForm();
            this.disableSubmit = false;
            } else {
            const toastEvent: ToastEvent = {
                message: 'File types should be PDF, JPEG, PNG',
                title: 'Invalid file format.',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            const inputName = `file-input${index}`;
            const element = this.$refs[inputName] as any;
            element[0].reset();
            }
        }
    }

    private validateForm() {
        const profileRequest = this.getProfileRequest();
        if (profileRequest.roles !== undefined) {
            if (this.checkRequiredDocuments(profileRequest.roles, profileRequest.documents,
            TransporterRequiredDocuments.documents)) {
                this.isFormValid = true;
            } else {
                this.isFormValid = false;
            }
        }
    }

    private async removeDocument(document: Document) {
        this.showDeleteConfirmBox = false;
        if (document.resourceId) {
            const response = await ObjectFactory.getFileService().
                deleteFile(document.resourceId, this.$store.state.serverUrl);
            if (response.success) {
                document.resourceId = '';
            }
            document.file = undefined;
            document.filename = '';
            this.savePartnerProfile();
        } else {
            document.file = undefined;
            document.filename = '';
        }
        this.validateForm();
    }

    private async saveDocuments() {
        const promises: Array<Promise<ApiResponse<UploadFileResponse>>> = [];
        const profileRequest: ProfileRequest = this.$props.request;
        const indexes: number[] = [];
        let index = 0;
        profileRequest.documents.forEach((document) => {
            if (document.file && !document.resourceId) {
                const formData = new FormData();
                formData.append('file', document.file as any);
                indexes.push(index);
                promises.push(ObjectFactory.getFileService()
                    .uploadFile(formData, this.$store.state.serverUrl));
            }
            index++;
        });
        if (promises.length >= 1) {
            const loaderEvent: LoaderEvent = {
                show: true,
                message: 'Uploading',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_LOADER, loaderEvent);
            Promise.all(promises).then((uploadDocumentResponses) => {
                let indexTemp = 0;
                uploadDocumentResponses.forEach((uploadDocumentResponse) => {
                    const documentIndex = indexes[indexTemp];
                    const document = profileRequest.documents[documentIndex];
                    delete document.file;
                    if (uploadDocumentResponse.data) {
                        document.resourceId = uploadDocumentResponse.data.fileName;
                    }
                    indexTemp++;
                });
            }).catch(() => {
                const toastEvent: ToastEvent = {
                    message: 'Failed to upload document',
                    title: 'Error!',
                    timeout: 5000,
                    varient: 'danger',
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            }).finally(() => {
                loaderEvent.show = false;
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_LOADER, loaderEvent);
                this.validateForm();
                this.savePartnerProfile();
                this.disableSubmit = true;
            });
        } else {
            this.savePartnerProfile();
        }
    }

    private async savePartnerProfile() {
        const profileRequest = this.getProfileRequest();
        if (profileRequest.updatePartnerProfileRequest.transporterProfile && this.sessionInfo.scopes.includes('transporter')) {
            profileRequest.updatePartnerProfileRequest.transporterProfile.documents = [];
            profileRequest.documents.forEach((document) => {
                if (profileRequest.updatePartnerProfileRequest.transporterProfile &&
                    profileRequest.updatePartnerProfileRequest.transporterProfile.documents && document.resourceId) {
                    if (this.checkDocumentRequired(document, ['FIRST_RESPONDER', 'NEMT', 'EMS'])) {
                        profileRequest.updatePartnerProfileRequest.transporterProfile.documents.push({
                            name: document.name,
                            resourceId: document.resourceId,
                            filename: document.filename,
                            description: document.description,
                        });
                    }
                }
            });
        }
        if (profileRequest.updatePartnerProfileRequest.homeHealthCareProfile && this.sessionInfo.scopes.includes('homeHealthCare')) {
            profileRequest.updatePartnerProfileRequest.homeHealthCareProfile.documents = [];
            profileRequest.documents.forEach((document) => {
                if (profileRequest.updatePartnerProfileRequest.homeHealthCareProfile &&
                    profileRequest.updatePartnerProfileRequest.homeHealthCareProfile.documents && document.resourceId) {
                    if (this.checkDocumentRequired(document, ['CNA', 'RN'])) {
                        profileRequest.updatePartnerProfileRequest.homeHealthCareProfile.documents.push({
                            name: document.name,
                            resourceId: document.resourceId,
                            filename: document.filename,
                            description: document.description,
                        });
                    }
                }
            });
        }
        const updatePartnerProfileResponse = await ObjectFactory.getPartnerService()
            .updatePartnerProfile(this.getProfileRequest().updatePartnerProfileRequest, this.$store.state.serverUrl);
        if (updatePartnerProfileResponse.success && this.isFormValid) {
            const messageBox: any = this.$refs.messageBox;
            messageBox.showModal();
            this.$props.request.isStepUDValid = true;
        }
    }
    private logout() {
        CommonUtils.logout(this.$store.state);
    }
    private checkDocumentRequired(document: any, roles?: string[]) {
        let required = false;
        if (roles) {
            roles.forEach((element) => {
                if (document.requiredFor && document.requiredFor.includes(element)) {
                    required = true;
                }
            });
        }
        return required;
    }
    private checkRequiredDocuments(roles: any[], uploadedDocuments: any[], allDocuments: any[]) {
        let status = false;
        let index = 0;
        const requiredDocuments = new Array();
        if (roles && allDocuments) {
            roles.forEach((role) => {
                allDocuments.forEach((document) => {
                    if (document.requiredFor && document.requiredFor.includes(role) && document.required === true) {
                        requiredDocuments.push(document.name);
                    }
                });
            });
        }
        if (requiredDocuments && uploadedDocuments) {
            requiredDocuments.forEach((requiredDocument) => {
                uploadedDocuments.forEach((uploadedDocument) => {
                    if (requiredDocument === uploadedDocument.name
                    && (uploadedDocument.resourceId || uploadedDocument.file)) {
                        index++;
                    }
                });
            });
        }
        if (index >= requiredDocuments.length) {
            status = true;
        } else {
            status = false;
        }
        return status;
    }
}
